


import React, { useState, useEffect, useRef } from "react";
import "./Management.css";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { CircularProgress } from '@mui/material';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
const API_BASE = "https://api.waraq.co/waraq/api/v1";

const styles = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  headerTitle: {
    fontWeight: '400',
    width: '20%',
    marginTop: '10px'
  },
  noRequests: {
    textAlign: "center",
    padding: "40px",
    margin: "40px 0",
    color: "#666",
    fontSize: "18px"
  },
  taskRow: {
    cursor: "pointer",
    margin: "30px 0px",
    padding: "10px 30px",
    borderRadius: "12px",
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    border: "1px solid #000"
  },
  taskField: {
    flex: '1 1 50px',
    minWidth: '50px'
  },
  fieldLabel: {
    fontSize: '14px',
    fontWeight: '500'
  },
  statusBadge: {
    padding: '6px 16px',
    borderRadius: '20px',
    fontWeight: '500',
    color: "#000",
    fontSize: '14px',
    backgroundColor: '#FF7777',
  },
  table: {
    marginTop: "10px",
    width: "100%"
  },
  tableHeader: {
    fontWeight: '500',
    color: "#000",
    fontSize: '14px'
  },
  link: {
    color: "blue",
    textDecoration: "underline",
    cursor: "pointer"
  },
  nextButton: {
    marginTop: '10px',
    fontSize: '14px',
    backgroundColor: "transparent",
    padding: "5px 25px",
    border: "1px solid #000",
    cursor: "pointer",
    borderRadius: "3px"
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    maxWidth: '400px',
    width: '90%',
    textAlign: 'center'
  },
  modalTitle: {
    margin: '0 0 20px 0',
    fontSize: '18px',
    color: '#333'
  },
  modalButtons: {
    display: 'flex',
    gap: '15px',
    justifyContent: 'center',
    marginTop: '25px'
  },
  cancelButton: {
    padding: '8px 20px',
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px'
  },
  confirmButton: {
    padding: '8px 20px',
    backgroundColor: '#3F302E',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px'
  },
  errorMessage: {
    backgroundColor: 'red'
  }
};

const Management = () => {

  const fileInputRefs = useRef({});


  const [requests, setRequests] = useState([]);
  const [openRequests, setOpenRequests] = useState({});
  const [currentOpenRequestId, setCurrentOpenRequestId] = useState(null);
  const [translators, setTranslators] = useState([]);
  const [proofreaders, setProofreaders] = useState([]);
  const [uploadingRows, setUploadingRows] = useState({});
  const [selectedFiles, setSelectedFiles] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const [showPopup, setShowPopup] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const [selectedTranslatorId, setSelectedTranslatorId] = useState(null);
  const [selectedProofreaderId, setSelectedProofreaderId] = useState(null);

  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [uploadMessage, setUploadMessage] = useState(null);
  const [successfulDelete, setSuccessfulDelete] = useState(null)


  const handleConfirmDelete = async () => {
    try {
      await axios.delete(
        `${API_BASE}/translate/docs/${selectedRowId}/template`,
        { headers: getAuthHeaders() }
      );
      setSuccessfulDelete('successful delete This Doc')
      setTimeout(() => {
        setSuccessfulDelete('');
      }, 3000);

      fetchDocumentsByRequestId(requestId, false);
      setDeleteDialogOpen(false);
      setSelectedRowId(null);
    } catch (err) {
      console.log('error when delete this doc', err.response.data.data);
    }

  };


  const handleDeleteClick = (rowId) => {
    setSelectedRowId(rowId);
    setDeleteDialogOpen(true);
  };

  const handleCancelDelete = () => {
    setDeleteDialogOpen(false);
    setSelectedRowId(null);
  };

  const getAuthHeaders = () => {
    const token = localStorage.getItem("jwtToken");
    return { Authorization: `${token}` };
  };

  const showMessage = (setter, message, duration = 3000) => {
    setter(message);
    setTimeout(() => setter(null), duration);
  };


  const fetchAllRequests = async () => {
    try {
      const { data } = await axios.get(
        `${API_BASE}/user/translate/requests/pending`,
        { headers: getAuthHeaders() }
      );

      const mappedData = data.data.map((req) => ({
        id: req.id,
        client: req.clientId,
        clientName: req.clientName,
        requestDate: new Date(req.requestDate).toLocaleDateString(),
        totalDocuments: req.totalDocuments,
        taskTitle: req.taskTitle,
        totalPages: req.totalPages,
        translator: req.translatorId,
        proofreader: req.proofreaderId,
        deliveryDate: new Date(req.deliveryDate).toLocaleDateString(),
        status: req.status,
      }));

      setRequests(mappedData);
    } catch (error) {
      console.error("Error fetching requests:", error);
      showMessage(setErrorMessage, "Failed to fetch requests");
    }
  };

  const fetchMembers = async () => {
    try {
      const { data } = await axios.get(
        `${API_BASE}/users?role=TRANSLATOR`,
        { headers: getAuthHeaders() }
      );

      const translatorsData = data.data.filter((u) => u.role === "TRANSLATOR");
      setTranslators(translatorsData);
      setProofreaders(translatorsData);
    } catch (error) {
      console.error("Error fetching members:", error);
    }
  };

  const fetchDocumentsByRequestId = async (id, shouldToggle = true) => {
    setRequestId(id);

    try {
      const { data } = await axios.get(
        `${API_BASE}/translate/docs?requestId=${id}`,
        { headers: getAuthHeaders() }
      );

      const mappedDocs = data.data.map((doc) => ({
        id: doc.id,
        document: doc.documentUrl,
        documentId: doc.documentId,
        finalTranslatedDocumentId: doc.finalTranslatedDocumentId,
        finalTranslatedDocumentUrl: doc.finalTranslatedDocumentUrl,
        templateUrl: doc.templateUrl,
        templateId: doc.templateId,
        translatedDocumentId: doc.translatedDocumentId,
        translatedDocumentUrl: doc.translatedDocumentUrl,
        creationDate: doc.creationDate,
      }));

      // Update the documents data
      setOpenRequests((prev) => ({
        ...prev,
        [id]: mappedDocs,
      }));

      // Only toggle open/close if shouldToggle is true
      if (shouldToggle) {
        setCurrentOpenRequestId((prevId) => 
          prevId === id ? null : id
        );
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
      showMessage(setErrorMessage, "Failed to fetch documents");
    }
  };

  const updateRequestStatus = async () => {
    if (!selectedTranslatorId || !selectedProofreaderId) {
      showMessage(setErrorMessage, "Please select both translator and proofreader");
      return;
    }

    try {
      await axios.patch(
        `${API_BASE}/translate/requests/${requestId}/translator`,
        {},
        {
          params: { userId: selectedTranslatorId },
          headers: getAuthHeaders()
        }
      );


      await axios.patch(
        `${API_BASE}/translate/requests/${requestId}/proofreader`,
        {},
        {
          params: { userId: selectedProofreaderId },
          headers: getAuthHeaders()
        }
      );


      await axios.patch(
        `${API_BASE}/translate/requests/${requestId}/status?status=TRANSLATING`,
        {},
        { headers: getAuthHeaders() }
      );

      showMessage(setSuccessMessage, "Status changed successfully to Translator");
      setShowPopup(false);

      await fetchAllRequests();

    } catch (error) {
      console.error("Error updating request:", error);
      const errorMsg = error.response?.data?.data || "Failed to update request status";
      showMessage(setErrorMessage, errorMsg);
      setShowPopup(false);
    }
  };

  const uploadTemplate = async (file, rowId) => {
    if (!file) return;

    try {
      setUploadingRows((prev) => ({ ...prev, [rowId]: true }));
      setSelectedFiles((prev) => ({ ...prev, [rowId]: file }));

      const formData = new FormData();
      formData.append("file", file);

      await axios.patch(
        `${API_BASE}/translate/docs/${rowId}/template`,
        formData,
        { headers: getAuthHeaders() }
      );

      showMessage(setUploadMessage, "Document uploaded successfully");
      // Pass false to update without closing
      await fetchDocumentsByRequestId(currentOpenRequestId, false);
    } catch (error) {
      console.error("Error uploading template:", error);
      showMessage(setErrorMessage, error?.response?.data?.data || "Upload failed");
    } finally {
      setUploadingRows((prev) => ({ ...prev, [rowId]: false }));
    }
  };

  const downloadFile = async (mediaId, name) => {
    try {
      console.log('name', name);

      let splitFileName = name?.split('.com/')[1];

      const url = `${API_BASE}/media/download/${mediaId}`;
      const response = await axios.get(url, {
        headers: getAuthHeaders(),
        responseType: "blob",
      });

      const blob = response.data;
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;


      let fileName = splitFileName;
      const contentDisposition = response.headers["content-disposition"];

      if (contentDisposition) {
        const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match?.[1]) {
          fileName = match[1].replace(/['"]/g, "");
        }
      }

      if (!fileName.includes(".")) {
        const contentType = response.headers["content-type"];
        const ext = contentType?.split("/")[1] || "bin";
        fileName = `${fileName}.${ext}`;
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
      showMessage(setErrorMessage, "Download failed");
    }
  };


  const handleTranslatorSelect = (e) => {
    const value = e.target.value;
    setSelectedTranslatorId(value && value !== "" ? Number(value) : null);
  };

  const handleProofreaderSelect = (e) => {
    const value = e.target.value;
    setSelectedProofreaderId(value && value !== "" ? Number(value) : null);
  };

  const handleFileChange = (event, rowId) => {
    const file = event.target.files?.[0];
    if (file) {
      uploadTemplate(file, rowId);
    }
  };

  const handleIconClick = (rowId) => {
    fileInputRefs.current[rowId]?.click();
  };

  const handleNextClick = () => {
    setShowPopup(true);
  };

  const handleCancel = () => {
    setShowPopup(false);
  };


  useEffect(() => {
    fetchAllRequests();
    fetchMembers();
  }, []);

  const renderTaskRow = (taskDetails) => (
    <div
      key={taskDetails.id}
      onClick={() => fetchDocumentsByRequestId(taskDetails.id, true)}
      className="task-row"
      style={styles.taskRow}
    >
      <div style={styles.taskField}>
        <strong style={styles.fieldLabel}>Client</strong>
        <br />
        {taskDetails?.clientName || "N/A"}
      </div>

      <div style={styles.taskField}>
        <strong style={styles.fieldLabel}>Request Date</strong>
        <br />
        {taskDetails.requestDate}
      </div>

      <div style={styles.taskField}>
        <strong style={styles.fieldLabel}>Task Title</strong>
        <br />
        {taskDetails?.taskTitle || "N/A"}
      </div>

      <div style={styles.taskField}>
        <strong style={styles.fieldLabel}>Total Pages</strong>
        <br />
        {taskDetails.totalPages}
      </div>

      <div style={styles.taskField}>
        <strong style={styles.fieldLabel}>Translator</strong>
        <br />
        {taskDetails.translator || "N/A"}
      </div>

      <div style={styles.taskField}>
        <strong style={styles.fieldLabel}>Proofreader</strong>
        <br />
        {taskDetails.proofreader || "N/A"}
      </div>

      <div style={styles.taskField}>
        <strong style={styles.fieldLabel}>Delivery Date</strong>
        <br />
        {taskDetails.deliveryDate}
      </div>

      <div style={styles.taskField}>
        <strong style={styles.fieldLabel}>Status</strong>
        <br />
        <span style={styles.statusBadge} className="status">
          {taskDetails.status}
        </span>
      </div>
    </div>
  );

  const renderDropdowns = () => (
    <div className="filters-wrapper">
      <div style={{ margin: 0  }}>
        <div className="dropdown-container">
          <div className="select-wrapper">
            <select className="custom-select" onChange={handleTranslatorSelect}>
              <option value="">Translator</option>
              {translators.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.firstName} {t.lastName}
                </option>
              ))}
            </select>
            <KeyboardArrowDownIcon className="arrow-icon" />
          </div>

          <div className="select-wrapper">
            <select className="custom-select" onChange={handleProofreaderSelect}>
              <option value="">Proofreader</option>
              {proofreaders.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.firstName} {p.lastName}
                </option>
              ))}
            </select>
            <KeyboardArrowDownIcon className="arrow-icon" />
          </div>
        </div>
      </div>
    </div>
  );

  const renderDocumentsTable = (docs) => (
    <table className="styled-table" style={styles.table}>
      <thead className="styled-thead">
        <tr>
          <th style={styles.tableHeader}>Document (PDF)</th>
          <th style={styles.tableHeader}>Template (Word)</th>
          <th style={styles.tableHeader}>Translation (Word)</th>
          <th style={styles.tableHeader}>Created At</th>
        </tr>
      </thead>
      <tbody className="styled-tbody">
        {docs.map((row) => (
          <tr className="styled-row" key={row.id}>
            <td className="styled-cell">
              <a
                style={styles.link}
                onClick={() => downloadFile(row.documentId, row.document)}
              >
                {row?.document.split('.com/')[1]};

              </a>
            </td>


            <td className="styled-cell">
              <input
                type="file"
                ref={(el) => (fileInputRefs.current[row.id] = el)}
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e, row.id)}
                accept="*/*"
              />

              {uploadingRows[row.id] ? (
                <CircularProgress size={16} style={{ color: "#1976d2" }} />
              ) : row.templateUrl ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <a
                    onClick={() => downloadFile(row.templateId, row.templateUrl)}
                    style={styles.link}
                  >
                    {row?.templateUrl.split(".com/")[1]?.length > 25
                      ? row?.templateUrl.split(".com/")[1].slice(0, 25) + "..."
                      : row?.templateUrl.split(".com/")[1]}
                  </a>

                  <DeleteIcon
                    onClick={() => handleDeleteClick(row.id)}
                    style={{ fontSize: "18px", color: "red", cursor: "pointer" }}
                  />
                </div>
              ) : (
                <FileUploadIcon
                  style={{ fontSize: "16px", cursor: "pointer" }}
                  onClick={() => handleIconClick(row.id)}
                />
              )}
            </td>


            <td className="styled-cell">
              {row.translatedDocumentUrl ? (
                <a
                  onClick={() => downloadFile(row.translatedDocumentId, row.translatedDocumentUrl)}
                  style={styles.link}
                >
                  {row?.translatedDocumentUrl.split('.com/')[1]};

                </a>
              ) : (
                "No file uploaded"
              )}
            </td>

            <td className="styled-cell">
              {row?.creationDate?.substring(0, 10) || "—"}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  const renderConfirmationModal = () => (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        <h3 style={styles.modalTitle}>
          Are you sure you want to change status to translate?
        </h3>
        <div style={styles.modalButtons}>
          <button onClick={handleCancel} style={styles.cancelButton}>
            Cancel
          </button>
          <button onClick={updateRequestStatus} style={styles.confirmButton}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );

  const renderMessage = (message, isError = false) => (
    <div
      className="popup-message"
      style={isError ? styles.errorMessage : {}}
    >
      {message}
    </div>
  );


  return (
    <div className="mangement-member">
      <div style={styles.container}>
        <div style={styles.header}>
          <h2 style={styles.headerTitle}>Request Management</h2>
        </div>
      </div>

      <div>
        {requests.length === 0 ? (
          <div style={styles.noRequests}>No requests found...</div>
        ) : (
          requests.map((taskDetails) => (
            <div key={taskDetails.id} style={{ marginBottom: "20px" }}>
              {renderTaskRow(taskDetails)}
              {currentOpenRequestId === taskDetails.id && openRequests[taskDetails.id] && (
                <>
                  {renderDropdowns()}
                  {renderDocumentsTable(openRequests[taskDetails.id])}

                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <button onClick={handleNextClick} style={styles.nextButton}>
                      NEXT
                    </button>
                  </div>
                </>
              )}
            </div>
          ))
        )}
      </div>


      {deleteDialogOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            maxWidth: '400px',
            width: '90%'
          }}>
            <h3 style={{ margin: '0 0 20px 0', fontSize: '18px', fontWeight: '600' }}>
              Confirm Delete
            </h3>
            <p style={{ margin: '0 0 30px 0', color: '#666' }}>
              Are you sure you want to delete this document?
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                onClick={handleCancelDelete}
                style={{
                  padding: '10px 20px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  backgroundColor: 'white',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmDelete}
                style={{
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '4px',
                  backgroundColor: 'red',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {showPopup && renderConfirmationModal()}
      {errorMessage && renderMessage(errorMessage, true)}
      {successMessage && renderMessage(successMessage)}
      {uploadMessage && renderMessage(uploadMessage)}
      {successfulDelete && renderMessage(successfulDelete)}


    </div>
  );
};

export default Management;
